import{LINK_TYPE as o,ANCHOR_TYPE as y,CUSTOM_LINK_TYPE as g}from"./types.js";const T=(e,i,r)=>{e.findEntityRanges(E=>{const n=E.getEntity();if(n!==null){const t=r.getEntity(n).getType();return t===o||t===y||t===g}return!1},i)};export{T as linkEntityStrategy};
//# sourceMappingURL=strategy.js.map
